"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateField = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importStar(require("react"));
function DateField(_a) {
    var name = _a.name, initialValue = _a.initialValue, setValue = _a.setValue;
    var onChange = (0, react_1.useCallback)(function (value) {
        if (!value) {
            setValue(undefined);
            return;
        }
        setValue(value);
    }, []);
    return (react_1.default.createElement(core_ui_1.DatePickerInput2.Uncontrolled, { name: name, initialValue: initialValue, onChange: onChange, format: "MM/DD/YYYY", timezone: "UTC" }));
}
exports.DateField = DateField;
